import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  -ms-flex-positive: 1;
  flex-grow: 1;
  position: relative;
`;
